import lazyLoading from './lazyLoading';

export default {
  name: 'Attachments',
  path: '/attachments/:id?',
  component: lazyLoading('attachments/Attachments'),
  meta: {
    title: 'schema.attachments',
    iconClass: 'far fa-file',
    to: '/attachments',
    auth: 'admin',
  },
  props: r => ({root: true, id: r.params.id}),
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/attachments.js